<template>
  <div>
    <a-card :bordered="false">
      <a-row type="flex" justify="space-around">
        <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
          <div class="login-wrap">
            <Register />
          </div>
        </a-col>
        <a-col
          :xs="0"
          :sm="0"
          :md="0"
          :lg="13"
          :xl="13"
          v-if="tenantInfo.loginBg"
        >
          <img
            style="width: 100%"
            class="cover"
            v-if="tenantInfo.loginBg"
            :src="tenantInfo.loginBg"
            alt=""
          />
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Register from "../components/user/Register";
export default {
  components: {
    Register,
  },
  data() {
    return {
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  },
  mounted() {
    window.document.title = "注册";
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.login-wrap {
  padding: 40px 40px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000039;
}
</style>